import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';
const License = ()=>{
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div  className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>用户協議</h2>
            <p>軟件許可及用户協議</p>
            <p>歡迎您使用<strong>Dreamehome</strong>軟件及服務<strong> </strong></p>
            <p>爲使用<strong>Dreamehome</strong>軟件及服務，追覓創新科技（蘇州）有限公司以及其關聯公司（以下簡稱“追覓”）在此特別提醒用户認真閲讀、充分理解本《軟件許可及用户協議》（下稱“本協議”）及《<strong>Dreamehome</strong>私隱政策》。用户應認真閲讀、充分理解本協議中各條款，特別涉及免除或者限制責任、爭議解決和法律適用的條款。免除或者限制責任的條款將以粗體標識，您需要重點閲讀。請您審慎閲讀並選擇接受或不接受本協議（未成年人應在法定監護人陪同下閲讀）。您的下載、安裝、使用本軟件以及帳號獲取和登錄等行爲將視爲對本協議的接受，並同意接受本協議各項條款的約束。
            </p>
            <p>一、總則</p>
            <p>1.1.
                本協議是您（如下也稱“用户”，指的註冊、登錄、使用、瀏覽本軟件及服務的個人或組織）與追覓及其運營合作單位（如下簡稱“合作單位”）之間關於用户下載、安裝、使用“Dreamehome”軟件（下稱“本軟件”）以及使用追覓相關服務所訂立的協議。
            </p>
            <p>1.2. 本軟件及服務是追覓提供的安裝在包括但不限於流動智能終端裝置上的軟件和服務，爲使用該智能終端的用户提供綁定、操作智能產品等服務等。</p>
            <p>二、軟件的獲取</p>
            <p>2.1. 用户應當按照追覓的官網、官方應用平台以及追覓授權的第三方網站、應用分發平台等追覓官方或追覓授權的渠道下載獲取本軟件產品。</p>
            <p>2.2
                請您謹防在非指定追覓官方或追覓授權的第三方獲取本軟件，以免流動終端裝置感染能破壞用户數據和獲取用户私隱信息的惡意程式。如果用户從未經追覓授權的第三方獲取本軟件或與本軟件名稱相同的安裝程式，追覓無法保證該軟件能夠正常使用，並對因此給您造成的損失不予負責。
            </p>
            <p>三、軟件的安裝與卸載</p>
            <p>3.1. 用户必須選擇與所安裝終端裝置相匹配的本軟件版本，否則，由於軟件與設備型號不相匹配所導致的任何軟件問題、設備問題或損害，均由用户自行承擔。</p>
            <p>3.2 因經營策略安排或調整等原因，不同地區的用户可使用Dreamehome服務的內容可能會存在差異，具體以Dreamehome實際提供的爲準。</p>
            <p>3.3 如您不再需要使用本軟件或需要安裝新版軟件，可以自行卸載。</p>
            <p>3.4 軟件新版本發佈後，追覓不保證舊版本軟件的繼續可用。</p>
            <p>3.5
                爲了改善用户體驗、完善服務內容，追覓有權不時地爲您提供本軟件替換、修改、升級版本，也有權爲替換、修改或升級收取費用，但將收費提前徵得您的同意。本軟件爲用户默認開通“升級提示”功能，視用户使用的軟件版本差異，追覓供給用户自行選擇是否需要開通此功能。軟件新版本發佈後，追覓不保證舊版本軟件的繼續可用。
            </p>
            <p>四、軟件的更新</p>
            <p>4.1 爲了增進用户體驗、完善服務內容，追覓可能不斷努力開發新的服務，並爲您不時提供軟件更新。</p>
            <p>4.2 爲了改善用户體驗或提高服務安全性、保證功能的一致性等目的，追覓有權對本軟件進行更新，或者對軟件的部分功能效果進行改變。</p>
            <p>4.3 本軟件新版本發布後，舊版本的軟件可能無法使用。追覓不保證舊版本軟件繼續可用，也不保證繼續對舊版本軟件提供相應的客服和維護服務，請您隨時核對並下載最新版本。</p>
            <p>五、使用規範</p>
            <p><strong>5.1. </strong>用户註冊與帳號：</p>
            <ul>
                <li>5.1. 要使用Dreamehome軟件服務，用户必須註冊一個用户帳户（以下簡稱您的“帳户”）並在提示的註冊表中提供關於您自己的特定信息。 您同意您所提交的所有信息均真實準確並且您會及時更新此類信息。</li>
                <li>5.1.2
                    創建帳户或使用Dreamehome軟件，即表示您確認接受本協議。您也確認您根據您所在的國家的法律已經成年；或者您根據您所在的國家的法律還未成年（“未成年人”），且您表明您已與您的父母或法定監護人共同閲讀本協議，且您和您的父母或監護人理解並同意本條款的條款和條件。如果您是父母或監護人，允許未成年人使用本軟件及服務，即表示您同意：(i)
                    監督未成年人使用本軟件及服務；(ii) 承擔與未成年人使用本軟件及服務相關的所有風險；(iii)承擔因未成年人使用本軟件及服務導致的任何法律責任；(iv) 確保您或未成年人提交的所有信息準確、真實；以及 (v)
                    承擔未成年人訪問和使用本軟件及服務導致的任何責任並受本條款約束。</li>
                <li>5.1.3 用户應當按照法律法規和服務要求，按相應頁面的提示準確提供並及時更新用户帳號的資料，以使之真實、及時、完整和準確。</li>
                <li>5.1.4 帳號的所有權歸追覓所有，用户完成申請註冊手續後，僅獲得帳號的使用權，且該使用權僅屬於初始申請註冊人。</li>
                <li>5.1.5 用户有責任妥善保管註冊帳户信息及帳户密碼的安全，用户需要對註冊帳户以及密碼下的行爲承擔法律責任。用户同意在任何情況下不向他人透露帳户及密碼信息。當在你懷疑他人在使用你的帳號時，你應立即通知追覓。</li>
            </ul>
            <p><strong>5.2. </strong>用户禁止的行爲：</p>
            <ul>
                <li>5.2.1. 刪除本軟件及其他副本上一切關於版權的信息，以及修改、刪除或避開本軟件爲保護知識產權而設置的技術措施；</li>
                <li>5.2.2. 對本軟件進行反向工程，如反彙編、反編譯或者其他試圖獲得本軟件的源代碼；</li>
                <li>5.23. 通過修改或偽造軟件運行中的指令、數據，增加、刪減、變動軟件的功能或運行效果，或者將用於上述用途的軟件、方法進行運營或向公眾傳播，無論這些行爲是否爲商業目的；</li>
                <li>5.2.4.
                    使用本軟件進行任何危害網絡安全的行爲，包括但不限於：使用未經許可的數據或進入未經許可的服務器/帳户；未經允許進入公眾網絡或者他人操作系統並刪除、修改、增加存儲信息；未經許可企圖探查、掃描、測試本軟件的系統或網絡的弱點或其它實施破壞網絡安全的行爲；
                    企圖干涉、破壞本軟件系統或網站的正常運行，故意傳播惡意程序或病毒以及其他破壞干擾正常網絡信息服務的行爲；偽造TCP/IP數據包名稱或部分名稱；</li>
                <li>5.2.5. 用户通過非追覓公司開發、授權或認可的第三方兼容軟件、系統登錄或使用本軟件及服務，或製作、發布、傳播上述工具；</li>
                <li>5.2.6.
                    未經追覓書面同意，用户對軟件及其中的信息擅自實施包括但不限於下列行爲：使用、出租、出借、複製、修改、鏈接、轉載、彙編、發表、出版，建立鏡像站點、擅自藉助本軟件發展與之有關的衍生產品、作品、服務、插件、外掛、兼容、互聯等；
                </li>
                <li>5.2.7. 利用本軟件發表、傳送、傳播、儲存違反當地法律法規的內容；</li>
                <li>5.2.8. 利用本軟件發表、傳送、傳播、儲存侵害他人知識產權、商業秘密等合法權利的內容；</li>
                <li>5.2.9. 利用本軟件批量發表、傳送、傳播廣告信息及垃圾信息；</li>
                <li>5.2.10. 其他以任何不合法的方式、爲任何不合法的目的、或以任何與本協議許可使用不一致的方式使用本軟件和追覓提供的其他服務；</li>
            </ul>
            <p>5.3. 信息發佈規範</p>
            <ul>
                <li>5.3.1．您可使用本軟件發表屬於您原創或您有權發表的觀點看法、數據、文字、信息、用戶名、圖片、照片、個人信息、音頻、視頻文件、鏈接等信息內容。您必須保證，您擁有您所上傳信息內容的知識產權或已獲得合法授權，您使用本軟件及服務的任何行爲未侵犯任何第三方之合法權益。
                </li>
                <li>5.3.2．您在使用本軟件時需遵守當地法律法規要求。</li>
                <li>5.3.3．您在使用本軟件時不得利用本軟件從事以下行爲，包括但不限於：</li>
            </ul>
            <p>5.3.3.1.製作、複製、發佈、傳播、儲存違反當地法律法規的內容；</p>
            <p>5.3.3.2.發布、傳送、傳播、儲存侵害他人名譽權、肖像權、知識產權、商業秘密等合法權利的內容；</p>
            <p>5.3.3.3.虛構事實、隱瞞真相以誤導、欺騙他人；</p>
            <p>5.3.3.4.發表、傳送、傳播廣告信息及垃圾信息；</p>
            <p>5.3.3.5.從事其他違反當地法律法規的行爲。</p>
            <p>5.3.3.6未經追覓許可，您不得在本軟件中進行任何諸如發布廣告、銷售商品的商業行爲。</p>
            <p><strong>5.4.</strong>您理解並同意：</p>
            <ul>
                <li>5.4.1. 追覓會對用戶是否涉嫌違反上述使用規範做出認定，並根據認定結果中止、終止對您的使用許可或採取其他依本約定可採取的限制措施；</li>
                <li>5.4.2. 對於用戶使用許可軟件時發佈的涉嫌違法或涉嫌侵犯他人合法權利或違反本協議的信息，追覓會直接刪除；</li>
                <li>5.4.3. 對於用戶違反上述使用規範的行爲對第三方造成損害的，您需要以自己的名義獨立承擔法律責任，並應確保追覓免於因此產生損失或增加費用；</li>
                <li>5.4.4．若用戶違反有關法律規定或協議約定，使追覓遭受損失，或受到第三方的索賠，或受到行政管理機關的處罰，用戶應當賠償追覓因此造成的損失和（或）發生的費用，包括合理的律師費、調查取證費用。</li>
            </ul>
            <p>六、軟件授權</p>
            <p>6.1. 在用戶同意遵守本協議及其《Dreamehome私隱政策》的情況下，追覓就本軟件給予用戶在其所在國境內一項個人的、不可轉讓、不可轉授權以及非獨佔性的有限許可。</p>
            <p>6.2.
                用戶可以爲非商業目的在單一台流動裝置上安裝、使用、顯示、運行本軟件。但用戶不得爲商業運營目的安裝、使用、運行本軟件，不可以對本軟件或者本軟件運行過程中釋放到任何終端裝置內存中的數據及本軟件運行過程中客戶端與服務器端的交互數據進行複製、更改、修改、掛接運行或創作任何衍生作品，形式包括但不限於使用插件、外掛或非經授權的第三方工具/服務接入本軟件和相關係統。如果需要進行商業性的銷售、複製和散發，例如軟件預裝和捆綁，必須獲得追覓的書面授權和許可。
            </p>
            <p>6.3 6.3 用戶不得未經追覓許可，將本軟件安裝在未經追覓明示許可的其他終端裝置上，包括但不限於機頂盒、遊戲機、電視機、DVD機等。</p>
            <p>6.4. 用戶可以爲使用本軟件及服務的目的複製本軟件的一個副本，僅用作備份。備份副本必須包含原軟件中含有的所有著作權信息。</p>
            <p>6.5. 除本《協議》明示授權外，追覓未授權給用戶其他權利，若用戶使用其他權利時須另外取得追覓的書面同意。</p>
            <p>七、責任限制及免責聲明</p>
            <p>7.1. 責任限制</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，您將自行承擔訪問和使用本軟件及服務可能面臨的風險。追覓明確排除因以下情形由您或其他任何人造成的責任、損失或損害，無論是基於合同、侵權（包括過失侵權）或其它任何依據：</p>
            <p>（<strong>1</strong>）<strong> </strong>利潤損失、收入損失、收益損失、數據丟失或商譽損失；</p>
            <p>（<strong>2</strong>）<strong> </strong>有關的人身傷害、特別、間接或衍生性損失或損害。無論追覓是否已經知悉或是否應該意識到上述損失出現的可能性，本協議中的限制和排除條款都將適用。</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，無論您何時對本軟件及服務的任何方面感到不滿意，您唯一的救濟措施都是停止訪問和使用本軟件及服務。在不影響前述限制的情況下，在您所在司法轄區適用法律允許的最大範圍內，追覓對您或其他人的任何申索、訴訟、責任、義務、損害、損失及成本的累計責任都不超過您使用本軟件及服務支付的價款，無論是基於合同、侵權（包括過失侵權）或其它任何依據。您理解並同意本協議中的免責聲明與責任限制公平合理。
            </p>
            <p>7.2.免責聲明</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，對於您或其他任何人因下列原因無法訪問或使用本軟件及服務導致的任何責任、損失、損害或賠償，追覓及其合作方不承擔任何責任：</p>
            <p><strong>(1) </strong>追覓對系統或軟硬件進行維護或升級導致本軟件及服務中止或終止；</p>
            <p><strong>(2) </strong>用戶因第三方如通訊線路故障、技術問題、網絡、流動終端裝置故障、系統不穩定性及其他各種不可抗力原因而遭受的一切損失；</p>
            <p><strong>(3)
            </strong>本軟件同大多數互聯網軟件一樣，受包括但不限於用戶原因、網絡服務質量、社會環境等因素的差異影響，可能受到各種安全問題的侵擾，如他人利用用戶的資料，造成現實生活中的騷擾；用戶下載安裝的其它軟件或訪問的其他網站中含有「特洛伊木馬」等病毒，威脅到用戶的終端裝置信息和數據的安全，繼而影響本軟件的正常使用等等；
            </p>
            <p><strong>(4) </strong>本軟件調用第三方系統或第三方軟件支持用戶的使用或訪問，其結果的安全性、準確性、有效性及其他不確定的風險，並由此若引發的任何爭議及損害</p>
            <p><strong>(5) </strong>超越追覓合理控制的其它原因。</p>
            <p><strong>7.3.
            </strong>部分國家的法律不允許合同中排除或限制某些保證、擔保或責任。若這些法律適用於您，則前述排除或限制條款的全部或部分可能不適用於您，您可享有額外的權利。本協議中的任何內容均不影響您作爲消費者應該享有的法定權利，您也無法通過同意本合同變更或放棄這些權利。
            </p>
            <p>八、第三方內容<strong>/</strong>服務說明</p>
            <p>8.1.
                追覓會不時與第三方網站、社交媒體平台、流動應用程式以及其他商品或服務（“第三方”）鏈接或合作。您能夠通過平台與該第三方互動，但這不代表追覓認可、監控或控制此類第三方或其行爲，這些第三方及其行爲受單獨的使用條款和私隱政策的約束。您應仔細閱讀任何第三方網站及其使用條款和私隱政策。追覓不對第三方的內容、政策或活動負責，且您自行承擔使用第三方內容和服務的風險。
            </p>
            <p>8.2. 用戶與第三方內容或服務提供方之間發生的任何爭議、糾紛應由用戶與第三方服務提供方自行協商解決，追覓不承擔任何責任。</p>
            <p>九、知識產權聲明</p>
            <p>9.1
                除另有特別聲明外，我們在本協議項下提供的產品和服務中的內容（包括但不限於頁面、文字、圖片、音頻、視頻、圖表等）、提供產品和服務時所依託應用程序、以及在產品和服務中所使用的商標及其他商業標識，其著作權、專利權、商標權或其他相關知識產權和合法權益均歸我們所有。
            </p>
            <p>9.2 上述及其他任何我們的產品和服務中包含的內容的知識產權均受到法律保護，未經我們或相關權利人事先書面許可，任何人不得以任何形式進行使用或創造相關衍生作品。</p>
            <p>十、協議的修改和終止</p>
            <p>10.1.一些司法管轄區不允許單方更新或變更消費條款，因此本段可能對您不適用。在您所在司法轄區適用法律允許的最大範圍內：</p>
            <p>（1）我們可能會不時更新這些條款。如果發生重大變更，我們將在Dreamehome或我們的官網上發布通知或向您發送通知。請閱讀全部變更。如果您不同意任何變更，請停止使用Dreamehome。如果在我們通知您變更後您繼續使用我們的Dreamehome，除非適用法律禁止，您將被視爲已接受了更新後的條款。
            </p>
            <p>（2）追覓和合作公司有權按需要修改或變更所提供的收費服務、收費標準、收費方式、服務費及服務條款。追覓在提供服務時，可能現在或日後對部分服務的用戶開始收取一定的費用如用戶拒絕支付該等費用，則不能在收費開始後繼續使用相關的服務。追覓和合作公司將盡最大努力通過電郵或其他方式通知用戶有關的修改或變更。
            </p>
            <p>（3）追覓保留在任何時候無需通知而修改、保留或關閉Dreamehome及其服務的權力。用戶已同意追覓無需因修改、保留或關閉Dreamehome及其服務的行爲對用戶或第三方承擔責任。</p>
            <p>（4）依據適用法律，追覓可以不承擔任何責任地在任何時間因任何原因終止或暫停用戶的賬戶、刪除您的檔案或任何用戶內容，或者限制您使用全部或部分本軟件及服務。</p>
            <p>（5）本條款在您的帳戶終止或您停止使用本軟件及服務後仍然有效。</p>
            <p>十一、適用法律及爭議解決</p>
            <p>11.1. 如果您在美國居住，則本協議將按照加利福尼亞州和美國法律解釋，而不考慮法律衝突條文。本協議而產生或與使用本軟件及服務有關的任何爭議應提交至位於加利福尼亞州舊金山的州或聯邦法院，除非雙方一致同意在其他地點進行訴訟。
                您和我們均同意加利福尼亞州舊金山市作爲審理地點並接受其屬人管轄。</p>
            <p>11.2．如果您在歐洲經濟體或英國居住，您同本協議在所有方面均受荷蘭法律管轄，但法律衝突規則除外，也不適用1980年《聯合國國際貨物銷售合同公約》。</p>
            <p>除禁止和限制消費者的任何法定權利的情形外，您因本協議產生的爭議的法律程序應得到解決並排他地受荷蘭阿姆斯特丹的適格法院管轄，但法律衝突規則除外</p>
            <p>如果您有任何投訴意見，請通過聯繫我們與我們聯繫。如果您覺得您的投訴沒有得到充分解決，您可以，但沒有義務，通過<a className="page"
                href="http://ec.europa.eu/odr">http://ec.europa.eu/odr</a>訪問在線爭議解決（ODR）平台。此外，您有權通過以下方式聯繫調解員來啓動調解程序：歐洲調解員協會（197，Boulevard
                Saint-Germain，75007 巴黎，聯繫電話：09 53 01 02 69），<a className="page"
                    href="http://www.mediationconso-ame.com/">http://www.mediationconso-ame.com/</a>。調解員將試圖獨立和公正地達成和解。在調解的情況下，各方可以自由接受或拒絕調解員提出的解決方案。
            </p>
            <p>11.3. 如果您在11.1和11.2款以外的國家及地區居住，則本協議受中華人民共和國法律管轄。
                在這種情況下，因本協議而產生或與使用本軟件及服務有關的任何爭議應提交上海國際經濟貿易仲裁委員會（「貿仲委」）進行仲裁，仲裁應根據申請仲裁時有效的貿仲委仲裁規則進行。 仲裁裁決是最終裁決，對雙方均有約束力。 仲裁庭應由三
                (3) 名仲裁員組成。仲裁地點應爲上海。 仲裁語言應爲中文。</p>
            <p>十二、其他</p>
            <p>12.1. 私隱政策</p>
            <p>追覓非常重視您的個人私隱信息，請認真查閱我們的《Dreamehome私隱政策》，《Dreamehome私隱政策》爲與本協議效力等同且不可分割的一部分。在任何時候，您的信息均依照《Dreamehome私隱政策》處理</p>
            <p>12.2. 本協議生效時間爲2021年8月28日。</p>
            <p>12.3. 本協議所有條款的標題僅爲閱讀方便，本身並無實際涵義，不能作爲本協議涵義解釋的依據。</p>
            <div className='height'></div>
        </div>
    )
}

export default License